export function totalItensLista(listaNfSaidaProdutos) {
  if (listaNfSaidaProdutos?.length) {
    const total = listaNfSaidaProdutos.reduce(
      (prevVal, elem) => prevVal + parseFloat(elem.subtotal),
      0
    );
    return total;
  }
}
